import {
  IForgotPasswordMailModel,
  IForgotPasswordModel,
  IRegisterModel,
  ITokenResponse,
  IUser,
} from "../models/User";
import $api, { API_URL } from "../http";
import axios from "axios";
import { getRefreshToken } from "../helper/auth";

class AuthServiceClass {
  async register(model: IRegisterModel) {
    return $api.post<{ message: string }>("api/otp-token/email", model);
  }

  async login(model: { email: string; password: string }) {
    const response = await $api.post<ITokenResponse>("api/auth/login", model);
    localStorage.setItem("access_token", response.data.accessToken);
    localStorage.setItem("refresh_token", response.data.refreshToken);
    return response;
  }

  async loginGoogle(model: { token: string }) {
    const response = await $api.post<ITokenResponse>("api/auth/login-google", model);
    localStorage.setItem("access_token", response.data.accessToken);
    localStorage.setItem("refresh_token", response.data.refreshToken);
    return response;
  }

  async loginApple(model: { token: string; firstName: string | null; lastName: string | null }) {
    const response = await $api.post<ITokenResponse>("api/auth/login-apple", model);
    localStorage.setItem("access_token", response.data.accessToken);
    localStorage.setItem("refresh_token", response.data.refreshToken);
    return response;
  }

  async loginFacebook(model: { token: string }) {
    const response = await $api.post<ITokenResponse>("api/auth/login-facebook", model);
    localStorage.setItem("access_token", response.data.accessToken);
    localStorage.setItem("refresh_token", response.data.refreshToken);
    return response;
  }

  async sendVerifyMail(model: { email: string; lang: string }) {
    return $api.post<{ message: string }>("api/otp-token/verify-email", model);
  }

  async refreshToken() {
    return await axios.post<ITokenResponse>(`${API_URL}/api/auth/refresh-token`, {
      token: getRefreshToken(),
    });
  }

  async getCurrentUser() {
    try {
      return await $api.get<IUser>("api/auth/current-user");
    } catch (e) {}
  }

  logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }

  async verifyOtpToken(token: string) {
    return await $api.get<{ status: string }>(`api/otp-token/verify/${token}`);
  }

  async forgotPassword(token: string, model: IForgotPasswordModel) {
    return await $api.put<any>(`api/users/forgot-password/${token}`, model);
  }

  async getUserByEmail(email: string) {
    return await $api.get<IUser>(`api/users/by-email/${email}`);
  }

  async sendForgotPasswordMail(model: IForgotPasswordMailModel) {
    return await $api.post<any>("api/otp-token/forgot-password", model);
  }
}

export const AuthService = new AuthServiceClass();
